var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      class: _vm.getClassNameActive,
      attrs: { type: "button", disabled: _vm.isFetching },
      on: { click: _vm.addOrRemove }
    },
    [_vm._v("\n  お気に入り\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }